export default __webpack_public_path__ + "/dist/images/restaurant-icon.be8cf75713b624e2f8d409c3bb4b3e3e.svg";